export enum MessageTypes {
    ALL = 'all',
    READ = 'read',
    UNREAD = 'unread',
};
